module.exports = __webpack_public_path__ + "static/ig_banner_07-a619963f3e896fce1db66d31691e882f.png";